import { Model, attr } from 'redux-orm';
import { createAction, createLoadConst } from '../util';

export default class Flags extends Model {
  static get modelName() {
    return 'Flags';
  }

  static reducer({ type, data, meta, reduxActionMeta }, Flags) {
    switch (type) {
      case LOAD_FLAGS.SUCCESS: {
        const currentMeta = meta || reduxActionMeta;
        const hasFlagResponse =
          currentMeta?.flagName &&
          data?.response &&
          typeof data.response.FlagValue !== 'undefined';
        if (hasFlagResponse) {
          Flags.filter(
            (flag) => flag.flagName === currentMeta.flagName
          ).delete();

          Flags.upsert({
            FlagValue: data.response.FlagValue,
            flagName: currentMeta.flagName,
            id: currentMeta.flagName,
          });
        } else {
          // Fallback only when we don't have a single-flag response (e.g. legacy batch shape)
          Flags.delete();
          data?.response?.data?.forEach((item) => Flags.upsert(item));
        }
        break;
      }
      default:
        break;
    }
  }

  /**
   * Declaring all data fields is recommended as the library doesn't have to
   * redefine getters and setters when instantiating Models
   * */
  static get fields() {
    return {
      id: attr(), // Use flagName as the unique identifier
      flagName: attr(), // Store the flag name for filtering
      FlagValue: attr(),
    };
  }
}

const name = Flags.modelName;

export const LOAD_FLAGS = createLoadConst(name);
export const loadFlags = createAction(LOAD_FLAGS);
